import React from 'react'
import WaitScreen from '@minicoursegenerator/wait-screen'
import {
  WAIT_SCREEN_GRAY_THEME_CLASS,
  WAIT_SCREEN_GRAY_THEME_OVERRIDES,
} from './theme-overrides'
import { PROGRESS_BAR_STYLES } from './progress-bar-styles'
import { useWaitScreenStyles } from './hooks/useWaitScreenStyles'

/**
 * Wrapper component for WaitScreen with MCG theme and styles applied
 * Encapsulates theme overrides and progress bar styling
 * Automatically applies global wait-screen styles on first use (lazy-loaded)
 *
 * @param {Object} props - WaitScreen props (slides, topic, description, etc.)
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Child elements (typically progress bars)
 * @returns {JSX.Element}
 */
export const WaitScreenWrapper = ({ className = '', children, ...waitScreenProps }) => {
  // Ensure global styles are applied exactly once, only when needed
  useWaitScreenStyles()

  return (
    <div className={`${WAIT_SCREEN_GRAY_THEME_CLASS} ${className}`}>
      <style>{WAIT_SCREEN_GRAY_THEME_OVERRIDES}</style>
      <style>{PROGRESS_BAR_STYLES}</style>
      <WaitScreen {...waitScreenProps} />
      {children}
    </div>
  )
}

export default WaitScreenWrapper
